<template>
  <div class="yht-backStage-bmgl">
    <div class="yht-backStage-bmgl_left" v-loading="loadingTree">
      <div class="yht-backStage-bmgl_left_title">
        <span class="yht-backStage-bmgl_left_title_name cp" @click="goTreeHome">南京市雨花台烈士陵园管理局</span>
        <span class="yht-backStage-bmgl_left_title_add cp" v-if="isShowAction"  @click="addDepart(firstNode)"></span>
      </div>
      <div class="yht-backStage-bmgl_left_search mt20">
        <el-input class="bmgl-input" placeholder="请输入搜索关键词···" v-model="filterText"></el-input>
        <div class="yht-backStage-bmgl_left_search_icon cp"></div>
      </div>
      <div class="yht-backStage-bmgl_left_tree mt20">
        <el-tree
          class="filter-tree"
          :data="treeList"
          :props="defaultProps"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          :filter-node-method="filterNode"
          ref="DepartTree">
           <span class="custom-tree-node" slot-scope="{ node, data }">
             <span class="custom-tree-node_name text-ellipsis" :title="node.label">{{ node.label }}</span>
             <span class="flex">
               <span class="yht-backStage-bmgl_tree_add" @click.stop="addDepart(data)" v-show="data.level !== '三级'"></span>
               <span class="yht-backStage-bmgl_tree_edit" @click.stop="editDepart(data)"></span>
               <span class="yht-backStage-bmgl_tree_delete" @click.stop="deleteDepart(data)"></span>
             </span>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="yht-backStage-bmgl_right">
      <div class="yht-backStage-bmgl-content_search">
        <el-input class="bmgl-input bmgl-table-input" placeholder="请输入搜索关键词···" v-model="keyWord" @keyup.enter.native="handleSearch"></el-input>
        <div class="yht-backStage-zhgl-content_search_icon cp" @click="handleSearch"></div>
      </div>
      <div class="yht-backStage-bmgl_table ">
        <el-table
          v-loading="loadingTable"
          ref="table"
          height="calc(100% - 80px)"
          tooltip-effect="light"
          :data="bmglList">
          <el-table-column label="" width="20" key="1"></el-table-column>
          <el-table-column label="序号" width="80" type="index" key="3">
            <span slot-scope="scope">{{ scope.$index + (pageNo - 1) * pageSize + 1 }}</span>
          </el-table-column>
          <el-table-column prop="name" label="用户名" key="4">
            <span slot-scope="scope" :title="scope.row.name">{{scope.row.name}}</span>
          </el-table-column>
          <el-table-column prop="positionName" label="岗位" key="5">
            <span slot-scope="scope" :title="scope.row.positionName">{{scope.row.positionName}}</span>
          </el-table-column>
          <template slot="empty">
            <span class="mt10" style="display:block;font-size: 12px;color: #666666;">暂无查询数据</span>
          </template>
        </el-table>
        <!-- 页码 -->
        <div class="yht-backStage-bmgl_page yht-backStage-page">
          <el-pagination
            v-show="total>15 && !loading"
            background
            layout="total, prev, pager, next"
            :current-page="pageNo"
            :page-size="pageSize"
            :total="total"
            @current-change="changePage">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="yht-backStage_dialog yht-backStage_bmgl_dialog">
      <el-dialog :title="depDialog" width="500px" :visible="showDepart"
                 :close-on-click-modal="false"
                 :before-close="handleDepartCancel">
        <div class="flex" v-show="depDialog === '添加子部门'">
          <div class="yht-backStage_dialog_label">上级部门</div>
          <div class="font-s16" v-text="selectNode.name"></div>
        </div>
        <div class="yht-backStage_dialog_input mt30" v-show="depDialog === '添加子部门' || depDialog === '编辑部门'">
          <div class="yht-backStage_dialog_label">部门名称</div>
          <el-input v-model.trim="departName" placeholder="" maxlength="255"></el-input>
        </div>
        <div class="font-s16" v-show="depDialog === '删除部门'">
          <div class="te-center">
            部门：<span v-text="selectNode.name + '及其子部门'"></span>
          </div>
          <div class="te-center mt20">将被删除</div>
        </div>
        <div class="yht-backStage_dialog_btnBox mt30">
          <div class="yht-backStage_dialog_btn yht-backStage_dialog_btnConfirm" @click="handleConfirm">确认</div>
          <div class="yht-backStage_dialog_btn yht-backStage_dialog_btnCancel" @click="handleDepartCancel">取消</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'bmgl',
  data () {
    return {
      // 加载树
      loadingTree: false,
      // 加载表格
      loadingTable: false,
      departmentNumber: '',
      treeList: [],
      // 搜索过滤
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 表格数据
      bmglList: [],
      // 搜索输入
      keyWord: '',
      // 搜索参数
      searchText: '',
      // 页数
      pageNo: 1,
      // 条数
      pageSize: 15,
      // 总数
      total: 0,
      firstNode: {
        id: '0000',
        name: '南京市雨花台烈士陵园管理局',
        addLevel: '一级'
      },
      // 选中的树节点
      selectNode: {},
      // 弹框title
      depDialog: '',
      // 部门弹框显示
      showDepart: false,
      // 上级部门
      superiorDep: '',
      // 添加的子部门名称
      departName: ''
    }
  },
  computed: {
    isShowAction () {
      return (
        localStorage.getItem('name') === 'admin' || localStorage.getItem('name') === 'sa'
      )
    }
  },
  watch: {
    filterText (val) {
      this.$refs.DepartTree.filter(val)
    }
  },
  mounted () {
    this.getTree()
    this.getAccountPage()
  },
  methods: {
    // 获取树形控件数据
    getTree () {
      const self = this
      self.loadingTree = true
      axios.get('/yuhuamenhu/department/getAllDepartmentType').then(json => {
        if (json.data.code === 200) {
          self.treeList = json.data.data
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loadingTree = false
      })
    },

    // 树的搜索过滤
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

    goTreeHome () {
      this.departmentNumber = ''
      this.getAccountPage()
    },

    handleNodeClick (data) {
      this.departmentNumber = data.id
      this.getAccountPage()
    },

    // 获取表格数据
    getAccountPage () {
      const self = this
      self.loadingTable = true
      const data = {
        departmentNumber: this.departmentNumber,
        searchKey: this.searchText.trim(),
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        userKind: 1
      }
      axios.post('/yuhuamenhu/accountManagement/getAccountPageDep', data).then(json => {
        if (json.data.code === 200) {
          self.bmglList = json.data.data.list
          self.total = json.data.data.total
        } else {
          self.$message.warning(json.data.message)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loadingTable = false
      })
    },

    // 点击搜索查询
    handleSearch () {
      this.searchText = this.keyWord
      this.pageNo = 1
      this.getAccountPage()
    },

    // 点击分页
    changePage (val) {
      this.pageNo = val
      this.getAccountPage()
    },

    // 添加部门
    addDepart (param) {
      this.depDialog = '添加子部门'
      this.selectNode = param
      if (this.selectNode.level === '一级') {
        this.selectNode.addLevel = '二级'
      } else if (this.selectNode.level === '二级') {
        this.selectNode.addLevel = '三级'
      }
      this.showDepart = true
    },

    editDepart (param) {
      this.depDialog = '编辑部门'
      this.departName = param.name
      this.selectNode = param
      this.showDepart = true
    },

    deleteDepart (param) {
      this.depDialog = '删除部门'
      this.selectNode = param
      this.showDepart = true
    },

    // 关闭弹框
    handleDepartCancel () {
      this.showDepart = false
      this.departName = ''
    },

    // 点击确认
    handleConfirm () {
      if (this.depDialog === '添加子部门') {
        this.saveDep()
      } else if (this.depDialog === '编辑部门') {
        this.updateDep()
      } else {
        this.deleteDep()
      }
    },

    // 添加子部门
    saveDep () {
      const self = this
      if (this.departName === '') {
        self.$message.warning('添加的子部门名称不能为空！')
        return
      }
      const data = {
        departmentLevel: this.selectNode.addLevel,
        departmentName: this.departName,
        superiorDepartmentNumber: this.selectNode.id
      }
      axios.post('/yuhuamenhu/department/saveDep', data).then(json => {
        if (json.data.code === 200) {
          self.$message.success(json.data.data)
          self.handleDepartCancel()
          self.getTree()
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 修改子部门
    updateDep () {
      const self = this
      if (self.departName === self.selectNode.name) {
        self.$message.warning('修改后的部门名称不能与原部门名称相同！')
        return
      } else if (this.departName === '') {
        self.$message.warning('编辑后的部门名称不能为空！')
        return
      }
      const data = {
        departmentName: this.departName,
        departmentNumber: this.selectNode.id
      }
      axios.post('/yuhuamenhu/department/updatePosition', data).then(json => {
        if (json.data.code === 200) {
          self.$message.success(json.data.data)
          self.handleDepartCancel()
          self.getTree()
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 删除部门
    deleteDep () {
      const self = this
      const data = {
        departmentName: this.selectNode.name
      }
      axios.post('/yuhuamenhu/department/deleteDepartment', data).then(json => {
        if (json.data.code === 200) {
          self.$message.success(json.data.data)
          self.handleDepartCancel()
          self.getTree()
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style>
  .yht-backStage-bmgl {
    position: relative;
    padding-left: 460px;
    width: 100%;
    height: calc(100% - 40px);
  }

  .yht-backStage-bmgl_left,
  .yht-backStage-bmgl_right {
    padding: 30px 30px 0;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 4px 50px 8px rgba(0, 0, 0, 0.06);
  }

  .yht-backStage-bmgl_left {
    position: absolute;
    top: 0;
    left: 0;
    width: 420px;
    height: 100%;
  }

  .yht-backStage-bmgl_right {
    position: relative;
    padding-top: 94px;
    width: 100%;
    height: 100%;
  }

  .yht-backStage-bmgl_left_title {
    position: relative;
    padding-left: 15px;
    width: 100%;
    height: 44px;
    line-height: 44px;
    background: rgba(139, 29, 19, 0.08);
  }

  .yht-backStage-bmgl_left_title_name {
    font-weight: bold;
    color: #3D3D3D;
  }

  .yht-backStage-bmgl_left_title_add {
    position: absolute;
    top: 14px;
    right: 15px;
    width: 16px;
    height: 16px;
    background: url("../images/add.png");
    background-size: 100% 100%;
  }

  .yht-backStage-bmgl_left_search {
    position: relative;
  }

  .bmgl-input{
    width: 100%;
    height: 38px;
    border-radius: 4px;
  }

  .bmgl-input .el-input__inner,
  .bmgl-input .el-input.is-active .el-input__inner,
  .bmgl-input .el-input__inner:focus,
  .bmgl-input .el-input__inner:hover{border-color: #ccc;}

  .bmgl-input >.el-input__inner {
    padding-right: 45px;
  }

  .yht-backStage-bmgl_left_search_icon {
    position: absolute;
    top: 50%;
    right: 10px;
    margin-top: -15px;
    width: 30px;
    height: 31px;
    background: url("../images/search.png");
    background-size: 100% 100%;
  }

  .yht-backStage-bmgl_left_tree {
    width: 100%;
    height: calc(100% - 122px);
    overflow: auto;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
  }

  .custom-tree-node .custom-tree-node_name {
    width: 222px;
  }

  .yht-backStage-bmgl_left_tree .el-tree {
    color: #3D3D3D;
  }

  .yht-backStage-bmgl_left_tree .el-tree-node__content {
    height: 40px;
  }

  .yht-backStage-bmgl_left_tree .el-tree-node__expand-icon {
    font-size: 18px;
    color: #8B1D13;
  }

  .yht-backStage-bmgl_left_tree .el-tree-node__expand-icon.is-leaf {
    color: transparent;
  }

  .yht-backStage-bmgl_left_tree .el-tree-node__content .el-tree-node__label {
    font-size: 16px;
    font-weight: bold;
  }

  .yht-backStage-bmgl_left_tree .el-tree-node__children .el-tree-node__label {
    font-weight: normal;
  }

  .yht-backStage-bmgl-content_search {
    position: absolute;
    top: 30px;
    right: 30px;
  }

  .bmgl-table-input {
    width: 360px;
  }

  .yht-backStage-bmgl_table {
    width: 100%;
    height: 100%;
  }

  .yht-backStage-bmgl_page {
    position: relative;
    margin-top: 10px;
    width: 100%;
    height: 50px;
  }

  .yht-backStage-bmgl_page .el-pagination {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .yht-backStage_bmgl_dialog .yht-backStage_dialog_input{
    margin-top: 30px;
  }

  .yht-backStage-bmgl_left_tree .yht-backStage-bmgl_tree_add {
    margin-right: 13px;
    width: 16px;
    height: 16px;
    background: url("../images/depart_add.png");
    background-size: 100% 100%;
  }

  .yht-backStage-bmgl_left_tree .yht-backStage-bmgl_tree_edit {
    margin-right: 13px;
    width: 13px;
    height: 16px;
    background: url("../images/depart_edit.png");
    background-size: 100% 100%;
  }

  .yht-backStage-bmgl_left_tree .yht-backStage-bmgl_tree_delete {
    width: 16px;
    height: 16px;
    background: url("../images/depart_delete.png");
    background-size: 100% 100%;
  }
</style>
